<!-- single表示单个颜色 -->
<template>
  <div
    class="football_cup_svgSingleCircle"
    v-show="currThemeObj.cssStyle"
    :class="dynamicClass"
    :style="{
      '--mixtmt_strokeWidth': `${strokeWidth * 2}px`,
      '--mixtmt_svgWidth': `${cx * 2}px`,
      '--mixtmt_svgCenterBgColor1_1': `${svgCenterBgColorArr[0]}`,
      '--mixtmt_svgCenterBgColor1_2': `${svgCenterBgColorArr[1]}`,
      '--mixtmt_svgCenterColor_total': `${svgCenterColorArr[0]}`,
      '--mixtmt_svgCenterColor_totalName': `${svgCenterColorArr[1]}`,
    }"
  >
    <div
      class="svg_area"
      :style="{ width: `${cx * 2}px`, height: `${cx * 2}px` }"
    >
      <span
        class="svgBg"
        :style="{
          width: `${cx * 2 - strokeWidth * 2}px`,
          height: `${cx * 2 - strokeWidth * 2}px`,
        }"
      ></span>
      <svg
        :width="cx * 2"
        :height="cx * 2"
        :viewbox="viewbox"
        v-if="renderSvgArr"
      >
        <defs>
          <linearGradient
            id="gradHome"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%"
            v-if="teamMode === 'home'"
          >
            <!-- 进度结束颜色 -->
            <stop
              :offset="(100 - progress) / 100"
              :style="{
                'stop-color':
                  progress === 0
                    ? 'transparent'
                    : currThemeObj.cssStyle.svgSingleColor1_1,
              }"
            />
            <!-- 进度开始颜色 -->
            <stop
              offset="100%"
              :style="{
                'stop-color':
                  progress === 0
                    ? 'transparent'
                    : currThemeObj.cssStyle.svgSingleColor1_2,
              }"
            />
          </linearGradient>
          <linearGradient
            id="gradAway"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%"
            v-if="teamMode === 'away'"
          >
            <!-- 进度结束颜色 -->
            <stop
              :offset="(100 - progress) / 100"
              :style="{
                'stop-color':
                  progress === 0
                    ? 'transparent'
                    : currThemeObj.cssStyle.svgSingleColor2_1,
              }"
            />
            <!-- 进度开始颜色 -->
            <stop
              offset="100%"
              :style="{
                'stop-color':
                  progress === 0
                    ? 'transparent'
                    : currThemeObj.cssStyle.svgSingleColor2_2,
              }"
            />
          </linearGradient>
        </defs>
        <circle
          v-for="(item, index) in renderSvgArr"
          :key="index"
          :class="[
            index == 0
              ? 'svg_bgColor'
              : teamMode == 'home'
              ? 'svg_homeColor'
              : 'svg_awayColor',
          ]"
          :cx="cx"
          :cy="cy"
          :r="r"
          stroke-linecap="round"
          :stroke-width="strokeWidth"
          fill="none"
          :transform="`matrix(0,-1,1,0,0,${cx * 2})`"
          :stroke-dasharray="item"
        ></circle>
      </svg>
      <div
        class="svg_infor"
        :class="svgCenterInforArr.length == 2 ? 'center2Row' : ''"
      >
        <span
          v-if="svgCenterInforArr.includes('val')"
          class="svg_infor_total"
          :style="{
            fontSize:
              svgCenterInforArr.length == 2
                ? svgCenterInforTextFontSizeArr[0]
                : svgCenterInforTextFontSizeArr[2],
          }"
        >
          <NumberScrolling
            :tarVal="svgData[keyArr[1]]"
            :unit="svgData.ceil ? svgData.ceil : ''"
          ></NumberScrolling>
        </span>
        <span
          v-if="svgCenterInforArr.includes('name')"
          class="svg_infor_totalName"
          :style="{ fontSize: svgCenterInforTextFontSizeArr[1] }"
          v-text="`${svgData[keyArr[0]]}`"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import NumberScrolling from '@components/compreSportsMeet/html/components/NumberScrolling'
export default {
  name: 'football_cup_svgSingleCircle',
  mixins: [cup_base_data_mixin],
  components: { NumberScrolling },
  props: {
    teamMode: {
      // 单个颜色是用主队颜色还是客队颜色
      type: String,
      default: 'home',
    },
    cx: {
      //圆点 x坐标
      type: Number,
      default: 67,
    },
    cy: {
      //圆点 y坐标
      type: Number,
      default: 67,
    },
    strokeWidth: {
      //描边宽度
      type: Number,
      default: 4,
    },
    svgData: {
      // svg渲染数据
      type: Object,
      default: () => {
        return null
        // val如果是0的话，必须是字符串的'0'； 在 svg => defs => linearGradient 里面的，当val为数字0则颜色会变为透明，原因是 linearGradient 里的标识用的id，所以上一个透明后面的会跟着透明，无论后面是否有值；因此必须是字符串的'0'
        // {
        //   val: 150,  //这个必须数字||字符串数字，不能为空，所以需要在传进来
        //   name: '11',
        //   key: 1,
        // }
      },
    },
    keyArr: {
      // 数据中需要的映射的字段名['name', 'val']
      type: Array,
      default: () => {
        return ['name', 'val']
      },
    },
    dynamicClass: {
      // 动态class名，针对不同场景增加的class样式
      type: String,
      default: '',
    },
    svgCenterInforArr: {
      // 中间显示的内容；['name', 'val']
      type: Array,
      default: () => {
        return ['val']
      },
    },
    svgCenterInforTextFontSizeArr: {
      // 中间显示的内容字体大小，固定【val(中间有两行时的val), name, val(中间只有一行时的val)】
      type: [Array, null],
      default: () => {
        return ['1.11vw', '0.974vw', '1.805vw']
      },
    },
    svgCenterBgColorArr: {
      type: Array,
      default: () => {
        return ['transparent', 'transparent']
      },
    },
    svgCenterColorArr: {
      type: Array,
      default: () => {
        return ['rgba(0, 0, 0, 0.85)', 'rgba(0, 0, 0, 0.6)']
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    r() {
      // 圆半径
      return this.cy - this.strokeWidth / 2 - 1
    },
    svgGirth() {
      // 圆周长
      return Math.floor(Math.PI * 2 * this.r)
    },
    viewbox() {
      // svg自带参数
      return `0 0 ${this.cx * 2} ${this.cx * 2}`
    },
    svgGirthPer() {
      // 占周长的百分比
      if (!this.svgData) {
        return null
      }
      return (Math.floor(this.progress) / 100) * this.svgGirth
    },
    progress() {
      if (!this.svgData) {
        return 0
      }
      return this.svgData[this.keyArr[1]] ? this.svgData[this.keyArr[1]] : 0
    },
    renderSvgArr() {
      //倒序的，第一个线段在最后一个，最后一个在第一个
      if (!this.svgData || !this.svgGirthPer) {
        return [`${this.svgGirth} 0`]
      }
      //   ['0 308 94 0', '0 202 94 106', '0 4 190 208']
      // return ['0 274 124 4', '0 205 61 136', '0 73 124 205', '0 4 61 337']
      console.debug('renderSvgArr:', this.svgData, [
        `${this.svgGirth} 0`,
        `${this.svgGirthPer} ${this.svgGirth - this.svgGirthPer}`,
      ])
      return [
        `${this.svgGirth} 0`,
        `${this.svgGirthPer} ${this.svgGirth - this.svgGirthPer}`,
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.football_cup_svgSingleCircle {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  width: 30%;
  &.theme_HTML_RECENTACH {
    justify-content: flex-end;
    width: 100%;
  }
  .svg_area {
    position: relative;
    .svgBg {
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 3;
      background: linear-gradient(
        180deg,
        var(--mixtmt_svgCenterBgColor1_1) 0%,
        var(--mixtmt_svgCenterBgColor1_2) 100%
      );
      border-radius: 50%;
      transform: translate(0, -50%);
    }
    svg {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 5;
      circle {
        -webkit-transition: stroke-dasharray 0.5s;
        transition: stroke-dasharray 0.5s;
      }
    }
    .svg_infor {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: var(--mixtmt_svgWidth);
      height: var(--mixtmt_svgWidth);
      padding: var(--mixtmt_strokeWidth);
      .svg_infor_total {
        color: var(--mixtmt_svgCenterColor_total);
        font-size: 1.805vw;
        line-height: 2.222vw;
        text-align: center;
      }
      .svg_infor_totalName {
        color: var(--mixtmt_svgCenterColor_totalName);
        font-size: 0.974vw;
        text-align: center;
      }
      &.center2Row {
        .svg_infor_total {
          font-size: 1.11vw;
        }
      }
    }
  }

  .svg_transparent {
    stroke: var(--mixtmt_whiteColor);
  }
  .svg_bgColor {
    stroke: var(--mixtmt_svgSingleColor0);
  }
  .svg_homeColor {
    stroke: url(#gradHome);
  }
  .svg_awayColor {
    stroke: url(#gradAway);
  }
}
</style>
